import { Clipboard , LucideIcon, Settings, Home, User} from 'lucide-react'

export const ROUTES_ACCESS: RoutesAccessType[] = [
    {route: '/', accessProfile: ['NOVO','ADMINISTRADOR','REPRESENTANTE']},
    {route: '/market-research', accessProfile: ['ADMINISTRADOR','REPRESENTANTE']},
    {route: '/market-research/settings', accessProfile: ['ADMINISTRADOR']},
    {route: '/market-research/details', accessProfile: ['ADMINISTRADOR','REPRESENTANTE']},
    {route: '/market-research/map', accessProfile: ['ADMINISTRADOR']},
    {route: '/masterdata/resale', accessProfile: ['ADMINISTRADOR']},
    {route: '/masterdata/product', accessProfile: ['ADMINISTRADOR']},
    {route: '/masterdata/pdv', accessProfile: ['ADMINISTRADOR']},
    {route: '/access/user', accessProfile: ['ADMINISTRADOR']},
    {route: '/access/user-permissions', accessProfile: ['ADMINISTRADOR']}
]
export const SIDENAV_ITEMS: SidenavItems[] = [
    {
        id: 1,
        label: 'Inicio',
        Icon: Home ,
        to: '/',
        accessProfile: ['NOVO','ADMINISTRADOR','REPRESENTANTE']
    }, 
    {
        id: 10,
        label: 'Planejamento de Pesquisa',
        Icon: Clipboard ,
        to: '/market-research',
        accessProfile: ['ADMINISTRADOR','REPRESENTANTE']
    },
    {
        id: 20,
        label: 'Dados Mestre',
        Icon: Settings,
        subItems: [
            {
                id: 20.2,
                label: 'Revenda',
                to: '/masterdata/resale'
            },
            {
                id: 20.3,
                label: 'Produto',
                to: '/masterdata/product'
            },
            {
                id: 20.1,
                label: 'PDVs',
                to: '/masterdata/pdv'
            },
        ],
        accessProfile: ['ADMINISTRADOR']
    },
    {
        id: 30,
        label: 'Acesso',
        Icon: User,
        subItems: [
            {
                id: 30.1,
                label: 'Usuário',
                to: '/access/user'
            },
             {
                id: 30.2,
                label: 'Permissões de Acesso',
                to: '/access/user-permissions'
            }
        ],
        accessProfile: ['ADMINISTRADOR']
    }
]
export type RoutesAccessType = {
    route: string,
    accessProfile: string[]
}

export type SidenavItems = {
    id: number
    label: string
    to?: string
    Icon?: LucideIcon
    subItems?: SidenavItems[]
    accessProfile?: string[]
}
